<template>
  <b-modal v-model="isActive" :can-cancel="true" @close="handleClose">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ t('Attention') }}</p>
      </header>
      <section class="modal-card-body">
        <p>{{ t('AreYouSure') }}</p>
      </section>
      <footer class="modal-card-foot">
        <b-button type="is-primary" data-test-id="areYouSureAccept" @click="handleYes">
          {{ t('Yes') }}
        </b-button>
        <b-button @click="handleCancel">
          {{ t('Cancel') }}
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  active: boolean
}>()

const emit = defineEmits<{
  (e: 'response', action: string): void
  (e: 'update:active', value: boolean): void
}>()

const { t } = useI18n()

const isActive = computed({
  get: () => props.active,
  set: (value: boolean) => emit('update:active', value)
})

const handleYes = () => {
  emit('response', 'yes')
  isActive.value = false
}

const handleCancel = () => {
  emit('response', 'cancel')
  isActive.value = false
}

const handleClose = () => {
  emit('response', 'cancel')
}
</script>
